import { render, staticRenderFns } from "./orderHistory.vue?vue&type=template&id=9ada7e76"
import script from "./orderHistory.vue?vue&type=script&lang=js"
export * from "./orderHistory.vue?vue&type=script&lang=js"
import style0 from "./orderHistory.vue?vue&type=style&index=0&id=9ada7e76&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports